// What the atlas does when the server says "too many requests".
//
// The atlas is public, so its partial reloads — a camera frame's regions, its
// wineries, a search keystroke — are reachable by anyone, and `PublicAtlas`
// puts a per-address rate limit in front of them. A refusal is a PLAIN-TEXT 429
// with no `X-Inertia` header, and Inertia's answer to any response that is not
// its own is to open a full-screen dialog with the body in it. For a navigation
// that has nowhere else to say so, that is right: the reader asked for a page
// and should be told why they did not get one. For a background reload it is a
// modal over the map announcing that a layer the reader never asked for by name
// was late — and each of those reloads already has a quieter way to say so.
//
// Opening a panel is a navigation that DOES have somewhere else to say so: the
// shell shows the panel's frame with the click, and when the page does not
// arrive the frame says "couldn't load" with a Retry (layouts/atlas_layout.tsx).
// So a refused panel visit, and the prefetch made ahead of one, decline the
// dialog too.
//
// Only the 429. Every other non-Inertia response still opens the dialog,
// because in development that dialog is the Rails error page, and swallowing it
// would turn a 500 into a layer that silently never draws.

export const RATE_LIMITED_STATUS = 429

export function isRateLimited(response: { status: number }) {
  return response.status === RATE_LIMITED_STATUS
}

/**
 * An `onHttpException` for a partial reload with nothing more to do about a
 * refusal than stay quiet. Returning `false` is what stops Inertia opening its
 * dialog; `undefined` leaves every other status to its default.
 */
export function declineRateLimitDialog(response: { status: number }): false | undefined {
  return isRateLimited(response) ? false : undefined
}
